function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
/* eslint-disable no-console */
import analyticsWrapper from "@xo-union/tk-analytics";
import SegmentAnalytics from "./segment/index.js";
import mixpanel from "./mixpanel/index.js";
var defaultWaitConfig = process.env.UNION_MEMBERSHIP_WAIT_FOR_ANALYTICS === 'true';
var callIfDefined = function callIfDefined(service, f, data) {
  if (typeof service[f] === 'function') {
    return service[f](data);
  }
  return null;
};
var _wait = /*#__PURE__*/new _WeakMap();
var _services = /*#__PURE__*/new _WeakMap();
var _maybeWaitForAllServicesTo = /*#__PURE__*/new _WeakMap();
var _getServicesList = /*#__PURE__*/new _WeakMap();
var MembershipAnalytics = /*#__PURE__*/function () {
  function MembershipAnalytics() {
    var _this = this;
    _classCallCheck(this, MembershipAnalytics);
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      analytics = _ref3.analytics,
      _ref3$wait = _ref3.wait,
      wait = _ref3$wait === void 0 ? defaultWaitConfig : _ref3$wait,
      _ref3$services = _ref3.services,
      services = _ref3$services === void 0 ? MembershipAnalytics.defaultServices({
        analytics: analytics
      }) : _ref3$services;
    _classPrivateFieldInitSpec(this, _wait, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _services, {
      writable: true,
      value: void 0
    });
    /* private methods */
    _classPrivateFieldInitSpec(this, _maybeWaitForAllServicesTo, {
      writable: true,
      value: function value(callback) {
        var _context;
        var promises = _mapInstanceProperty(_context = _classPrivateFieldGet(_this, _getServicesList).call(_this)).call(_context, function (_ref) {
          var _ref4 = _slicedToArray(_ref, 2),
            name = _ref4[0],
            service = _ref4[1];
          return (callback(service) || _Promise.resolve())["catch"](function (error) {
            console.warn("".concat(name, " failed to report."));
            console.error(error);
          });
        });
        if (_classPrivateFieldGet(_this, _wait)) {
          return _Promise.all(promises);
        }
        return _Promise.resolve();
      }
    });
    _classPrivateFieldInitSpec(this, _getServicesList, {
      writable: true,
      value: function value() {
        return _Object$entries(_classPrivateFieldGet(_this, _services));
      }
    });
    _classPrivateFieldSet(this, _wait, wait);
    _classPrivateFieldSet(this, _services, services);
  }
  _createClass(MembershipAnalytics, [{
    key: "reportSignUp",
    value: function reportSignUp(data) {
      return _classPrivateFieldGet(this, _maybeWaitForAllServicesTo).call(this, function (service) {
        return callIfDefined(service, 'reportSignUp', data);
      });
    }
  }, {
    key: "reportLogIn",
    value: function reportLogIn(data) {
      return _classPrivateFieldGet(this, _maybeWaitForAllServicesTo).call(this, function (service) {
        return callIfDefined(service, 'reportLogIn', data);
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      var _context2;
      return _forEachInstanceProperty(_context2 = _classPrivateFieldGet(this, _getServicesList).call(this)).call(_context2, function (_ref2) {
        var _ref5 = _slicedToArray(_ref2, 2),
          service = _ref5[1];
        return callIfDefined(service, 'reset');
      });
    }
  }]);
  return MembershipAnalytics;
}();
export { MembershipAnalytics as default };
_defineProperty(MembershipAnalytics, "defaultServices", function () {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref6$analytics = _ref6.analytics,
    analytics = _ref6$analytics === void 0 ? analyticsWrapper : _ref6$analytics;
  return {
    segment: new SegmentAnalytics({
      analytics: analytics
    }),
    mixpanel: mixpanel
  };
});